export enum Dashboard2ColumnType {
  DASHBOARD_ROW_INVALID = 0,
  DASHBOARD_COLUMN_CHART,
  DASHBOARD_COLUMN_TEXT_BOX,
  DASHBOARD_COLUMN_ANALYSIS,
  DASHBOARD_COLUMN_FEEDBACK_GALLERY,
}

export const DASHBOARD_REDIRECT_ID_PARAM = 'redirect-dashboard-id';
export const DASHBOARD_REDIRECT_ROW_INDEX_PARAM =
  'redirect-dashboard-row-index';

export const DASHBOARD_ROW_MIN_HEIGHT = 150;
export const DASHBOARD_ROW_DEFAULT_HEIGHT = 600;
export const DASHBOARD_ROW_MAX_HEIGHT = 900;

export const DASHBOARD_CARD_ANALYSIS_ALIAS_DATASET_KEY =
  'data-dashboard-card-analysis-alias';

export const DASHBOARD_CARD_CHART_ALIAS_DATASET_KEY =
  'data-dashboard-card-chart-alias';

export const DASHBOARD_ANALYSIS_ALIAS_SEARCH_PARAM_KEY = 'analysis_alias';
